module.exports = __webpack_public_path__ + "img/beginning2.f041b8f1.webp";